const GettingStartedCard = ({ steps }) => {
  if (!steps.length) return null;

  const allCompleted = steps.every((step) => step.completed);
  if (allCompleted) return null;

  return (
    <div className="bg-[#1f464b] rounded-2xl p-[16px] shadow-2xl border border-[#046c4e] relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none"></div>

      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between relative z-10 mb-4">
        <div>
          <h2 className="text-[22px] font-bold text-white tracking-tight">
            Getting started
          </h2>
          <p className="text-sm text-white/90 mt-1 font-medium">
            Do these in order to unlock full campaign performance.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 relative z-10">
        {steps.map((step) => {
          const isNext =
            !step.completed && steps.find((s) => !s.completed)?.id === step.id;

          return (
            <button
              key={step.id}
              type="button"
              onClick={step.action}
              className={`text-left rounded-xl p-4 transition-all duration-300 group relative flex flex-col h-full ${
                isNext
                  ? 'bg-white shadow-[0_10px_40px_-10px_rgba(0,0,0,0.2)] scale-[1.02] ring-2 ring-[#feb443] z-10'
                  : 'bg-white/95 hover:bg-white shadow-sm hover:translate-y-[-2px]'
              } ${step.completed ? 'opacity-90' : ''}`}
            >
              <div className="flex items-center justify-between mb-4 w-full">
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold shadow-sm transition-colors ${
                    step.completed
                      ? 'bg-[#1f464b] text-white'
                      : isNext
                      ? 'bg-[#feb443] text-white'
                      : 'bg-gray-100 text-gray-500'
                  }`}
                >
                  {step.completed ? (
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={3}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    step.id
                  )}
                </div>

                {isNext && (
                  <span className="text-[10px] font-bold uppercase tracking-wider text-[#9a6b1e] bg-[#feb443]/20 px-2 py-1 rounded-full">
                    Current Step
                  </span>
                )}
                {step.completed && (
                  <span className="text-[10px] font-bold uppercase tracking-wider text-[#1f464b] bg-[#1f464b]/10 px-2 py-1 rounded-full">
                    Done
                  </span>
                )}
              </div>

              <div className="flex-1">
                <h3
                  className={`font-bold text-[16px] mb-2 leading-tight ${
                    step.completed ? 'text-gray-700' : 'text-gray-900'
                  }`}
                >
                  {step.title}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed font-medium">
                  {step.description}
                </p>
              </div>

              <div
                className={`flex items-center gap-1.5 text-xs font-bold transition-all pt-4 border-t ${
                  isNext
                    ? 'text-[#b47d23] border-gray-100'
                    : 'text-gray-400 border-transparent group-hover:text-[#1f464b] group-hover:border-gray-100'
                }`}
              >
                {step.completed ? (
                  <span className="text-[#1f464b] flex items-center gap-1">
                    Completed
                    <svg
                      className="w-3 h-3"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </span>
                ) : (
                  <>
                    <span>Start now</span>
                    <svg
                      className="w-3 h-3 transition-transform group-hover:translate-x-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GettingStartedCard;
